"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _LeftSidebarLayout = _interopRequireDefault(require("./LeftSidebarLayout"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _LeftSidebarLayout.default;
exports.default = _default;